// extracted by mini-css-extract-plugin
export default {"NewOrderForm":"NewOrderForm_NewOrderForm__txEIl","NewOrderFormRow":"NewOrderForm_NewOrderFormRow__03Ta9"};